module.exports = __webpack_public_path__ + "static/media/category11.e1da9b6c.jpg";